module.exports = __webpack_public_path__ + "img/37.d792c745.svg";